// 是否是叶子节点
export default function isLeafNode(node) {
  return node.children == null || node.children.length === 0;
}